import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {Frame, FrameData} from "types/Frame";
import deserializeFrame from "services/ngage/deserializers/frame";

/**
 * Get all frames (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<Frame> | null>(`/frames?page=${page}`)

    if (response.data) {
        response.data.data = response.data.data.map(deserializeFrame)
    }

    return response.data
}

/**
 * Get a single frame
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<Frame | null>(`/frames/${id}`)
    return response.data? deserializeFrame(response.data) : null
}

/**
 * Get the download URL for a frame asset
 *
 * @param id
 * @param subdomain
 */
const downloadUrl = (id: number, subdomain?: string | null) => {
    const operatorParameter = subdomain? `?operator=${subdomain}` : '';
    return `${client.defaults.baseURL}/frames/${id}/asset${operatorParameter}`
}

/**
 * Store a new frame
 *
 * @param data
 */
const store = async (data: FrameData) => {
    const response = await client.post<Frame | null>('/frames', data)
    return response.data? deserializeFrame(response.data) : null
}

/**
 * Update an existing frame
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: FrameData) => {
    const response = await client.put<Frame | null>(`/frames/${id}`, data)
    return response.data? deserializeFrame(response.data) : null
}

/**
 * Permanently delete a frame
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/frames/${id}`)
    return response.status === 204
}

const frames = {
    all,
    get,
    downloadUrl,
    store,
    update,
    destroy
}

export default frames;